(function () {
    'use strict';

    angular.module("imApp").factory("travelWageSetRatesService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1503,
                    parameters: parms || {}
                });
            },
            listRates: function (parms) {
                return $ihttp.post({
                    method: 1504,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1505,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
